export function getDateFormatParts(
  locale?: string,
): Intl.DateTimeFormatPartTypes[] {
  if (!locale) {
    return [];
  }

  try {
    const format = Intl.DateTimeFormat(locale, {
      dateStyle: 'short',
      timeStyle: 'medium',
    });

    return format
      .formatToParts(Date.now())
      .filter((part) => part.type !== 'literal')
      .map((part) => part.type);
  } catch {
    return [];
  }
}

export enum SupportedDateParts {
  DAY = 'DAY',
  MONTH = 'MONTH',
  YEAR = 'YEAR',
}

const supportedPartsValues = Object.values(SupportedDateParts);

export const isSupportedDatePart = (
  part: Uppercase<Intl.DateTimeFormatPartTypes> | Intl.DateTimeFormatPartTypes,
): part is SupportedDateParts =>
  (supportedPartsValues as string[]).includes(part.toUpperCase());
